// src/components/ProductErrorBoundary.js
// Error boundary specifically for product modules
import React from 'react';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
import ErrorBoundary from './ErrorBoundary';

const ProductErrorFallback = ({ error, onRetry, productName = 'Product' }) => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 mb-4">
          <AlertTriangle className="h-6 w-6 text-orange-600" />
        </div>
        
        <h1 className="text-lg font-semibold text-gray-900 mb-2">
          {productName} Error
        </h1>
        
        <p className="text-sm text-gray-600 mb-6">
          There was a problem loading the {productName.toLowerCase()} module. 
          This might be a temporary issue.
        </p>

        <div className="space-y-3">
          <button
            onClick={onRetry}
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
          >
            Try Again
          </button>
          
          <button
            onClick={handleGoBack}
            className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

const ProductErrorBoundary = ({ children, productName, ...props }) => {
  return (
    <ErrorBoundary
      {...props}
      fallback={({ error, onRetry }) => (
        <ProductErrorFallback 
          error={error} 
          onRetry={onRetry} 
          productName={productName}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ProductErrorBoundary;
